// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateThaiPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if(!(phoneNumberValue && phoneNumberValue.trim())) {
    return { id: 'empty' };
  }

  if(phoneNumberValue.length < 8) {
    return { id: 'min-length' };
  }

  if(!/^\d+$/.test(phoneNumberValue)) {
    return { id: 'only-numbers' };
  }
}
